import DeclineOrganizationInviteModal from './DeclineOrganizationInviteModal';

export default DeclineOrganizationInviteModal;
